import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";


export default class Dashboard extends Component {
  componentDidMount() {
    var role = localStorage.getItem('Role');
    if(role != "ADMIN"){
      alert("You are not authorized to view the page")
      window.location.href = "/"
    }
  }
  render() {
    return (
      <div class="main-wrapper">
        <Header></Header>
        <div className="main-content">
          <Menu></Menu>
          <div className="content-right-wrapper">
            <div className="container">
              <div className="dashboard-btns-wrapper">
                {/* <Link className="dashboard-btns" to="/insights">
                Insights
                </Link> */}
                <Link className="dashboard-btns" to="/testimonials">
                  Testimonials
                </Link>
                <Link className="dashboard-btns" to="/stories">
                  Stories
                </Link>
                <Link className="dashboard-btns" to="/career-tracks">
                  Master Class
                </Link>
                <Link className="dashboard-btns" to="/expertise">
                  Expertise
                </Link>
                <Link className="dashboard-btns" to="/skills">
                  Skills
                </Link>
                <Link className="dashboard-btns" to="/experience">
                  Experience
                </Link>
                <Link className="dashboard-btns" to="/education">
                  Education
                </Link>
                <Link className="dashboard-btns" to="/priceRange">
                  Price Range
                </Link>
                <Link className="dashboard-btns" to="/country">
                  Country
                </Link>
                <Link className="dashboard-btns" to="/modeOfLearning">
                  Mode of learning
                </Link>
                <Link className="dashboard-btns" to="/institution">
                  Institution
                </Link>
                <Link className="dashboard-btns" to="/personna">
                  Personna
                </Link>
                <Link className="dashboard-btns" to="/goals">
                  Goals
                </Link>
                <Link className="dashboard-btns" to="/storyCategory">
                  Story Category
                </Link>
                <Link className="dashboard-btns" to="/userReport">
                  Report
                </Link>
              </div>
            </div>

          </div>
        </div>

        <Footer></Footer>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/admin/dashboard.jsx